// Исходные данные для расчетов
let step = 200000;
let lump = Number($('input[name=franchise_rights]:checked').val());
let trakerCost = 7000;
let officeOpen = 0;

let currentInvestorSliderValue = 0;
let currentInvestorSliderCalc = 0;

let selectFranchiseCity = $('#select-franchise-city');
let exclusiveLumpOutput = $('#franchise-exclusive-lump');
let nonExclusiveLumpOutput = $('#franchise-non-exclusive-lump');

$(function () {
    selectCity();
});

selectFranchiseCity.on('change', selectCity);

function selectCity () {
    let population = selectFranchiseCity.val();
    let name = $("option:selected", selectFranchiseCity).data('name');

    if (['Москва', 'Санкт-Петербург'].indexOf(name) !== -1) {
        franchiseExclusiveRadio.val(3000000);
        franchiseNonExclusiveRadio.val(500000);
    } else if (population >= 1000000) {
        franchiseExclusiveRadio.val(1500000);
        franchiseNonExclusiveRadio.val(300000);
    } else if (population >= 500000 && population < 1000000) {
        franchiseExclusiveRadio.val(900000);
        franchiseNonExclusiveRadio.val(200000);
    } else {
        franchiseExclusiveRadio.val(500000);
        franchiseNonExclusiveRadio.val(150000);
    }
    exclusiveLumpOutput.html(addDots(franchiseExclusiveRadio.val()));
    nonExclusiveLumpOutput.html(addDots(franchiseNonExclusiveRadio.val()));
    lump = Number($('input[name=franchise_rights]:checked').val());
    valueOutput(currentInvestorSliderCalc, currentInvestorSliderValue);
}

let franchiseRightsRadio = $('input[name=franchise_rights]');
let franchiseExclusiveRadio = $('#franchise_rights-exclusive');
let franchiseNonExclusiveRadio = $('#franchise_rights-non_exclusive');
franchiseRightsRadio.on('change', function () {
    franchiseRightsRadio.parent().removeClass('active');
    $('input[name=franchise_rights]:checked').parent().addClass('active');
    lump = Number($('input[name=franchise_rights]:checked').val());
    valueOutput(currentInvestorSliderCalc, currentInvestorSliderValue);
});

// Слушатель событие смены значения слайдера
$(document).on('input', 'input[type="range"]', function (e) {
    let element = e.target;
    currentInvestorSliderValue = element.value;
    currentInvestorSliderCalc = calculate(element.value);
    valueOutput(currentInvestorSliderCalc, currentInvestorSliderValue);
});

// Инициализация слайдера
let inputRange = $('input[type="range"]');
inputRange.rangeslider({polyfill: false});
for (let i = inputRange.length - 1; i >= 0; i--) {
    let element = inputRange[i];
    currentInvestorSliderValue = element.value;
    currentInvestorSliderCalc = calculate(element.value);
    valueOutput(currentInvestorSliderCalc, currentInvestorSliderValue);
}

var months = [60];
for (var i = 0; i < 60; i++)
{
    months[i] = i + 1;
}

// Добавление точек между триадами
function addDots(nStr) {
    nStr += '';
    let x = nStr.split('.');
    let x1 = x[0];
    let x2 = x.length > 1 ? '.' + x[1] : '';
    let rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + '.' + '$2');
    }
    return x1 + x2;
}

// Расчет показателей от вложенной суммы
function valueOutput(value, highlight) {
    if (inputRange.length > 0) {

        // Поля для вывода расчетов
        let startInvestmentsOutput = $('.rangeslider-output-container').children('output')[0];
        let officeOpenCostOutput = $('#office-open-cost')[0];
        let carTrackerCostOutput = $('#car-tracker-cost')[0];
        let totalStartCostOutput = $('#total-start-cost')[0];
        let monthProfitOutput = $('#month-profit')[0];

        // Выполнение расчетов
        let officeTotalCost = 10000 + value * 0.005;
        let trackerTotalCost = value / step * trakerCost;
        let totalStartCost = value + officeTotalCost + trackerTotalCost + lump;
        let monthProfit = (value * 2 - Math.floor(value * 2 * 0.28)) / 12;

        // Вывод полученных разультатов
        startInvestmentsOutput.innerHTML = addDots(value);
        officeOpenCostOutput.innerHTML = addDots(officeTotalCost);
        carTrackerCostOutput.innerHTML = addDots(trackerTotalCost);
        totalStartCostOutput.innerHTML = addDots(totalStartCost);
        monthProfitOutput.innerHTML = addDots(monthProfit);

        // Управление свечением круга
        $('.franchise-calculator-inner-highlight').css('opacity', 0.04 * highlight)

    }
}

// Слушатель событие смены значения слайдера
// $(document).on('input', 'input[type="range"]', function (e) {
//     let element = e.target;
//     let calc = calculate(element.value);
//     valueOutput(calc, element.value);
// });

// Функция расчета
function calculate(value) {
    let calc = 0;
    for (let i = 0; i < value; i++) {
        if (i < 5) {
            calc = calc + step
        }
        if (i > 4 && i < 10) {
            calc = calc + step * 2;
        }
        if (i > 9 && i < 17) {
            calc = calc + step * 5;
        }
        if (i > 16) {
            calc = calc + step * 25;
        }
    }
    return calc;
}